import { render } from "./MHome.vue?vue&type=template&id=e5321688&scoped=true"
import script from "./MHome.vue?vue&type=script&lang=js"
export * from "./MHome.vue?vue&type=script&lang=js"

import "./MHome.vue?vue&type=style&index=0&id=e5321688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5321688"]])

export default __exports__